import React, { Component } from 'react';
import '../css/Footer.css';
import Vas from '../Vas';
import revisionNumber from '../RevisionNumber.js';

class Footer extends Component
{
    render(){
        let currentYear = new Date();
        return (
          <div className={"footer"}>
            { Vas.Copyright + " "+ currentYear.getFullYear()}
            <div id={"RevisionNumber"} style={{ float: 'right', width: '80px'}}>2.{revisionNumber}</div>
          </div>
        );
    }
}
export default Footer;
